module.exports = __webpack_public_path__ + "img/pethouse25.fe3c4903.jpg";